import { AttachMoney } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import EmailIcon from '@mui/icons-material/Email';
import {
    Autocomplete, Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup, Stack, TextField,
    Typography
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import { pdf } from '@react-pdf/renderer';
import { useEffect, useRef, useState } from 'react';
import { BookingListData, BookingListGenerate, ConfirmationGenerate, ConfirmationSingle, InvoiceGenerate, InvoiceSingle } from '../components/GeneratePDF.js';
import firebaseDb from "../firebase-config";

export default function FormDialog(props) {
    const { open, setOpen, formType, event, onDownloadCalendar } = props;
    const title = `${formType} Event`;
    const [stage, setStage] = useState(event.stage);
    const [date, setDate] = useState(event.date);
    const tempMonth = (date !== undefined) ? new Date(event.date.replace(/-/g, '/')).toLocaleString('default', { month: 'long' }) : "";
    const tempYear = (date !== undefined) ? new Date(event.date.replace(/-/g, '/')).getFullYear() : "";
    const tempDay = (date !== undefined) ? new Date(event.date.replace(/-/g, '/')).toLocaleString('default', { weekday: 'long' }) : "";
    const dayOfWeek = (date !== undefined) ? new Date(event.date).getDay()+1 : "";
    const [weekDay, setWeekDay] = useState(new Date(event.date).getDay()+1);
    const [month, setMonth] = useState(tempMonth);
    const [year, setYear] = useState(tempYear);
    const [startTime, setStartTime] = useState(event.startTime);
    const [endTime, setEndTime] = useState(event.endTime);
    const [price, setPrice] = useState(event.price);
    const [performers, setPerformers] = useState(event.performers);
    const [email, setEmail] = useState(event.email);
    const [clients, setClients] = useState({});
    const [clientsList, setClientsList] = useState();
    const [events, setEvents] = useState({});
    const [isTimeCustom, setIsTimeCustom] = useState(false);
    const [isPriceCustom, setIsPriceCustom] = useState(false);
    const [matchingEvent, setMatchingEvent] = useState(false);
    const [matchingEventStartTime, setMatchingEventStartTime] = useState(event.startTime);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const [savePriceForClient, setSavePriceForClient] = useState(false);

    // ── Rebooking automation state ────────────────────────────────────────
    const [versionPromptOpen, setVersionPromptOpen] = useState(false);
    const [versionNumber, setVersionNumber] = useState(2);
    const [rebookingEventData, setRebookingEventData] = useState(null);
    const [isCreatingDrafts, setIsCreatingDrafts] = useState(false);
    const [draftsStatus, setDraftsStatus] = useState('');
    const tokenClientRef = useRef(null);
    const [authToken, setAuthToken] = useState('');

    // Google API credentials (same as Home.js)
    const CLIENT_ID = '939526187420-cotungv99ei31r3jgdfut3v0718drqk4.apps.googleusercontent.com';
    const SCOPES = "https://www.googleapis.com/auth/gmail.compose";
    const MAX_GMAIL_ATTACHMENT_BYTES = 18 * 1024 * 1024;

    const d = new Date();
    let day = d.getDay();

    // ── Initialize Google Identity Services ───────────────────────────────
    useEffect(() => {
        const initGis = () => {
            try {
                tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
                    client_id: CLIENT_ID,
                    scope: SCOPES,
                    callback: (response) => {
                        if (response && response.access_token) {
                            setAuthToken(response.access_token);
                        }
                    },
                });
            } catch (error) {
                console.error("Error initializing GIS in AddEditEvent:", error);
            }
        };

        if (window.google && window.google.accounts) {
            initGis();
        } else {
            const script = document.createElement('script');
            script.src = "https://accounts.google.com/gsi/client";
            script.async = true;
            script.defer = true;
            script.onload = initGis;
            document.body.appendChild(script);
        }
    }, []);

    useEffect(() => {
        firebaseDb.child('database/clients').on('value', snapshot => {
            if (snapshot.val() != null) {
                setClients(snapshot.val());
            }
        });
    }, []);

    useEffect(() => {
        firebaseDb.child('database/events').on('value', snapshot => {
            if (snapshot.val() != null) {
                setEvents(snapshot.val());
            }
        });
    }, []);

    useEffect(() => {
        let tempClientsList = [];
        tempClientsList = Object.keys(clients).map((key) => {
            return {
                label: clients[key].stage,
                emailLabel: clients[key].email,
                labelPerformer: clients[key].performers ? clients[key].performers.join(", ") : "",
                id: key,
                defaultPay: clients[key].defaultPay,
                splitCheck: clients[key].splitCheck
            };
        });
        setClientsList(tempClientsList);
    }, [clients]);

    useEffect(() => {
        setWeekDay(dayOfWeek);

        const defaultValues = (() => {
            setMatchingEvent(false);
            Object.keys(events).map((key) => {
                if (events[key].date === event.date) {
                    setMatchingEventStartTime(events[key].startTime);
                    setMatchingEvent(true);
                }
                return matchingEvent;
            });

            var tempStartTime = "17:00";
            var tempEndTime = ((dayOfWeek >= 1 && dayOfWeek <= 4) || dayOfWeek === 7) ? "19:00" : "19:30";

            if (matchingEvent === true && matchingEventStartTime === "17:00") {
                if ((dayOfWeek >= 1 && dayOfWeek <= 4) || dayOfWeek === 7) {
                    tempStartTime = "19:00";
                    tempEndTime = "21:00";
                } else {
                    tempStartTime = "19:30";
                    tempEndTime = "22:00";
                }
            }
            return {
                stage: "",
                email: "NO_EMAIL_FOR_ARTIST",
                performers: "",
                time: tempStartTime + "-" + tempEndTime,
                startTime: tempStartTime,
                endTime: tempEndTime,
                price: 185
            };
        })();

        setStage((event.stage !== undefined) ? event.stage : defaultValues["stage"]);
        setEmail((event.email !== undefined) ? event.email : defaultValues["email"]);
        setPerformers((event.performers !== undefined) ? event.performers : defaultValues["performers"]);
        setDate(event.date);
        const tempMonth = (event.date !== undefined) ? new Date(event.date.replace(/-/g, '/')).toLocaleString('default', { month: 'long' }) : "";
        const tempYear = (event.date !== undefined) ? new Date(event.date.replace(/-/g, '/')).getFullYear() : "";
        setMonth(tempMonth);
        setYear(tempYear);

        if (event.startTime !== undefined && event.endTime !== undefined) {
            setStartTime(event.startTime);
            setEndTime(event.endTime);
            const tempTime = event.startTime + "-" + event.endTime;
            const isWeekday = (dayOfWeek >= 1 && dayOfWeek <= 4) || dayOfWeek === 7;
            const validTimesForDay = isWeekday
                ? ["17:00-19:00", "19:00-21:00"]
                : ["17:00-19:30", "19:30-22:00"];
            setIsTimeCustom(!validTimesForDay.includes(tempTime));
        } else {
            setStartTime(defaultValues["startTime"]);
            setEndTime(defaultValues["endTime"]);
            setIsTimeCustom(false);
        }

        if (event.price !== undefined) {
            const tempPrice = event.price;
            setPrice(tempPrice);
            setIsPriceCustom((tempPrice !== 185 && tempPrice !== 380) ? true : false);
        } else {
            setPrice(defaultValues["price"]);
            setIsPriceCustom(false);
        }
    }, [open, formType, event, weekDay]);

    const handleTimeChange = (event) => {
        if (event.target.value !== "custom") {
            setIsTimeCustom(false);
            const [tempStart, tempEnd] = event.target.value.split("-");
            setStartTime(tempStart);
            setEndTime(tempEnd);
        } else {
            setIsTimeCustom(true);
            setStartTime(undefined);
            setEndTime(undefined);
        }
    };

    const handlePriceChange = (event) => {
        if (event.target.value !== "custom") {
            setIsPriceCustom(false);
            setPrice(parseInt(event.target.value));
        } else {
            setIsPriceCustom(true);
            setPrice(undefined);
        }
    };

    const handleClose = () => { setOpen(false); };

    // ── Convert File to base64 ────────────────────────────────────────────
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => {
                const bytes = new Uint8Array(reader.result);
                let binary = '';
                for (let i = 0; i < bytes.byteLength; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                resolve(btoa(binary));
            };
            reader.onerror = reject;
        });
    };

    // ── Convert blob to File object ───────────────────────────────────────
    const blobToFile = (blob, fileName) => {
        return new File([blob], fileName, { type: 'application/pdf' });
    };

    // ── Create a single Gmail draft ───────────────────────────────────────
    const createGmailDraft = async (accessToken, toAddresses, ccAddresses, bccAddresses, subject, body, attachmentFiles) => {
        const boundary = '--------' + Math.random().toString(36).substring(2, 15);

        let mimeMessage = '';
        mimeMessage += `To: ${toAddresses.join(', ')}\r\n`;
        if (ccAddresses && ccAddresses.length > 0) {
            mimeMessage += `Cc: ${ccAddresses.join(', ')}\r\n`;
        }
        if (bccAddresses && bccAddresses.length > 0) {
            mimeMessage += `Bcc: ${bccAddresses.join(', ')}\r\n`;
        }
        mimeMessage += `Subject: ${subject}\r\n`;
        mimeMessage += 'MIME-Version: 1.0\r\n';
        mimeMessage += `Content-Type: multipart/mixed; boundary="${boundary}"\r\n\r\n`;

        mimeMessage += `--${boundary}\r\n`;
        mimeMessage += 'Content-Type: text/plain; charset="UTF-8"\r\n';
        mimeMessage += 'Content-Transfer-Encoding: 7bit\r\n\r\n';
        mimeMessage += body + '\r\n\r\n';

        for (const file of attachmentFiles) {
            if (file) {
                const base64Content = await fileToBase64(file);
                mimeMessage += `--${boundary}\r\n`;
                mimeMessage += `Content-Type: ${file.type || 'application/octet-stream'}; name="${file.name}"\r\n`;
                mimeMessage += `Content-Disposition: attachment; filename="${file.name}"\r\n`;
                mimeMessage += 'Content-Transfer-Encoding: base64\r\n\r\n';
                mimeMessage += base64Content + '\r\n\r\n';
            }
        }

        mimeMessage += `--${boundary}--`;

        const encoded = window.btoa(unescape(encodeURIComponent(mimeMessage)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');

        const controller = new AbortController();
        const requestTimeout = setTimeout(() => controller.abort(), 120000);

        try {
            const response = await fetch('https://gmail.googleapis.com/gmail/v1/users/me/drafts', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                signal: controller.signal,
                body: JSON.stringify({ message: { raw: encoded } })
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ message: response.statusText }));
                throw new Error(`Failed to create draft: ${errorData.error?.message || errorData.message}`);
            }
        } catch (fetchError) {
            if (fetchError.name === 'AbortError') {
                throw new Error('Timed out creating draft. Please try again.');
            }
            throw fetchError;
        } finally {
            clearTimeout(requestTimeout);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    //  createRebookingDrafts
    //
    //  Creates all 10 Gmail drafts for a rebooking:
    //    6 calendar emails — fixed recipients, version number in subject
    //    2 booking list emails — fixed recipients, version number in subject
    //    1 invoice email — CC Thomas/APMontgomery/Jared, Revised in subject
    //    1 confirmation email — BCC new artist, Revised in subject
    //
    //  Note: Calendar JPEG must be added manually in Gmail since it comes
    //  from the physical handwritten calendar photo.
    // ─────────────────────────────────────────────────────────────────────────
    const createRebookingDrafts = async (versionNum, rebookEvent, rebookVenue, rebookBookings, rebookInvoice, rebookConfirmation) => {
        setIsCreatingDrafts(true);
        setDraftsStatus('Requesting Google sign-in...');

        try {
            // ── Get access token ──────────────────────────────────────────
            let accessToken = authToken;

            if (!accessToken) {
                await new Promise((resolve, reject) => {
                    if (tokenClientRef.current) {
                        tokenClientRef.current.callback = (response) => {
                            if (response && response.access_token) {
                                setAuthToken(response.access_token);
                                accessToken = response.access_token;
                                resolve();
                            } else {
                                reject(new Error('Google sign-in failed or was cancelled.'));
                            }
                        };
                        tokenClientRef.current.requestAccessToken({ prompt: 'consent' });
                    } else {
                        reject(new Error('Google Identity Services not initialized.'));
                    }
                });
            }

            const monthYear = `${rebookEvent.month} ${rebookEvent.year}`;
            const vLabel    = `V${versionNum}`;
            const to        = ['musicmattersbookings@gmail.com'];
            const venueName = rebookVenue?.name === "Renaissance-Exchange" ? "Exchange" : (rebookVenue?.name || "Exchange");
            const timeSuffix = rebookEvent?.startTime === "17:00" ? "#1" : "#2";

            // ── Generate documents ────────────────────────────────────────
            setDraftsStatus('Generating revised documents...');

            // Booking List PDF
            const blDoc  = BookingListGenerate({ bookings: rebookBookings, venue: rebookVenue, month: rebookEvent.month, year: rebookEvent.year });
            const blBlob = await pdf(blDoc).toBlob();
            const blFile = blobToFile(blBlob, `${venueName} Booking List-${monthYear} ${vLabel}.pdf`);

            // Invoice PDF
            const invoiceDoc  = InvoiceGenerate(rebookInvoice, rebookVenue);
            const invoiceBlob = await pdf(invoiceDoc).toBlob();
            const invoiceFile = blobToFile(invoiceBlob, `${venueName} Invoice-${rebookInvoice?.dateForFile} ${timeSuffix}-Revised.pdf`);

            // Confirmation PDF
            const confirmDoc  = ConfirmationGenerate(rebookConfirmation, rebookVenue);
            const confirmBlob = await pdf(confirmDoc).toBlob();
            const confirmFile = blobToFile(confirmBlob, `${venueName} Artist Confirmation-${rebookConfirmation?.dateForFile} ${timeSuffix}-Revised.pdf`);

            // ── Email body text ───────────────────────────────────────────
            const calBody = '';
            const blBody  = '';
            const invBody = '';
            const conBody = '';

            // ── Build all 10 drafts ───────────────────────────────────────
            const drafts = [

                // ── CALENDAR EMAIL 1: James Boheim, Luis Quezada ──────────
                // Booking List attached; JPEG added manually in Gmail
                {
                    to, cc: ['James.Boheim@renaissancemontgomery.com', 'Luis.Quezada@renaissancemontgomery.com'],
                    bcc: [],
                    subject: `Exchange Calendar-${monthYear} ${vLabel}`,
                    body: calBody, attachments: []
                },

                // ── CALENDAR EMAIL 2: Rudi Williams — Originals ───────────
                {
                    to, cc: ['Rudi.Williams@renaissancemontgomery.com'],
                    bcc: [],
                    subject: `Exchange Calendar-Originals-${monthYear} ${vLabel}`,
                    body: calBody, attachments: []
                },

                // ── CALENDAR EMAIL 3: BCC group (no Steve Arnold) ─────────
                {
                    to, cc: [],
                    bcc: ['sheupel@montgome.gannett.com', 'sheupel@gannett.com', 'Montgomeryhotspots@gmail.com'],
                    subject: `Renaissance/Exchange Calendar-${monthYear} ${vLabel}`,
                    body: calBody, attachments: []
                },

                // ── CALENDAR EMAIL 4: Alex Hejazi ─────────────────────────
                {
                    to, cc: ['ahejazi@parkingmgt.com'],
                    bcc: [],
                    subject: `Exchange Calendar-${monthYear} ${vLabel}`,
                    body: calBody, attachments: []
                },

                // ── CALENDAR EMAIL 5: Greer Borland — personal note ───────
                {
                    to, cc: ['gborland@rtjgolf.com'],
                    bcc: [],
                    subject: `Exchange Calendar-${monthYear} ${vLabel}`,
                    body: `[ADD YOUR PERSONAL NOTE HERE]\n\n${calBody}`,
                    attachments: []
                },

                // ── CALENDAR EMAIL 6: BCC group ───────────────────────────
                {
                    to, cc: [],
                    bcc: ['rick@groundfloorusa.com', 'hew2240@aol.com', 'segwaymontgomery@gmail.com', 'tduvernay@eji.org'],
                    subject: `Exchange Calendar-${monthYear} ${vLabel}`,
                    body: calBody, attachments: []
                },

                // ── BOOKING LIST EMAIL 1: James Boheim, Luis Quezada ──────
                {
                    to, cc: ['James.Boheim@renaissancemontgomery.com', 'Luis.Quezada@renaissancemontgomery.com'],
                    bcc: [],
                    subject: `Exchange Booking List-${monthYear} ${vLabel}`,
                    body: blBody, attachments: [blFile]
                },

                // ── BOOKING LIST EMAIL 2: Thomas, APMontgomery, Jared ─────
                {
                    to, cc: ['Thomas.Lewis@renaissancemontgomery.com', 'APMontgomery@renaissancemontgomery.com', 'Jared.Clay@renaissancemontgomery.com'],
                    bcc: [],
                    subject: `Exchange Booking List-${monthYear} ${vLabel}`,
                    body: blBody, attachments: [blFile]
                },

                // ── INVOICE EMAIL: Thomas, APMontgomery, Jared ────────────
                {
                    to, cc: ['Thomas.Lewis@renaissancemontgomery.com', 'APMontgomery@renaissancemontgomery.com', 'Jared.Clay@renaissancemontgomery.com'],
                    bcc: [],
                    subject: `Exchange Invoice-${rebookInvoice?.dateForFile} ${timeSuffix}-Revised`,
                    body: invBody, attachments: [invoiceFile]
                },

                // ── CONFIRMATION EMAIL: artist BCC ────────────────────────
                {
                    to,
                    cc: [],
                    bcc: [rebookEvent.email && rebookEvent.email !== 'NO_EMAIL_FOR_ARTIST' ? rebookEvent.email : ''],
                    subject: `Exchange Artist Confirmation-${rebookConfirmation?.dateForFile} ${timeSuffix}-Revised`,
                    body: conBody, attachments: [confirmFile]
                },
            ];

            // ── Create all drafts one by one ──────────────────────────────
            let created = 0;
            for (const draft of drafts) {
                setDraftsStatus(`Creating draft ${created + 1} of ${drafts.length}...`);
                await createGmailDraft(
                    accessToken,
                    draft.to,
                    draft.cc,
                    draft.bcc,
                    draft.subject,
                    draft.body,
                    draft.attachments
                );
                created++;
            }

            setDraftsStatus(`✅ All ${created} drafts created! Check your Gmail Drafts folder.`);
            alert(
                `✅ ${created} rebooking drafts created in Gmail!\n\n` +
                `Remember to:\n` +
                `1. Add the Calendar JPEG to the 6 calendar email drafts\n` +
                `2. Add your personal note to the Greer Borland draft\n\n` +
                `Then review and send!`
            );

        } catch (error) {
            console.error('Error creating rebooking drafts:', error);
            setDraftsStatus(`❌ Failed: ${error.message}`);
            alert(`Could not create rebooking drafts:\n\n${error.message}`);
        } finally {
            setIsCreatingDrafts(false);
        }
    };

    // ── Handle adding/editing events ──────────────────────────────────────
    const submitEvent = async () => {
        let clientID = "";

        Object.keys(clientsList).forEach((key) => {
            if (clientsList[key].label === stage) {
                clientID = clientsList[key].id;
            }
        });

        const finalPrice = Number(price);

        const newEvent = {
            stage: stage,
            email: email,
            performers: performers,
            date: date,
            startTime: startTime,
            endTime: endTime,
            price: finalPrice,
            clientID: clientID,
            venue: event.venue,
            start: date + "T" + startTime,
            end: date + "T" + endTime,
            month: month,
            year: year,
            venue_month_year: event.venue + "__" + month + "__" + year,
            splitCheck: currentClient?.splitCheck ?? false
        };

        try {
            let wasCancelled = false;
            let cancelledRefKey = null;

            if (formType === "Edit") {
                await firebaseDb.child("database/events/" + event.eventID).set(newEvent);
            } else {
                // Check for previous cancellations on this date
                const cancellationsSnapshot = await firebaseDb.child('database/cancellations').once('value');
                const cancellations = cancellationsSnapshot.val();

                if (cancellations) {
                    Object.entries(cancellations).forEach(([key, cancelled]) => {
                        if (cancelled.date === date) {
                            wasCancelled = true;
                            cancelledRefKey = key;
                        }
                    });
                }

                // Add the new event
                await firebaseDb.child("database/events").push(newEvent);

                // Clear the cancellation log entry
                if (wasCancelled && cancelledRefKey) {
                    await firebaseDb.child('database/cancellations/' + cancelledRefKey).remove();
                }
            }

            // Save custom pay rate if checkbox was ticked
            if (savePriceForClient && clientID) {
                await firebaseDb.child("database/clients/" + clientID).update({
                    defaultPay: finalPrice
                });
            }

            setOpen(false);

            if (formType === "Edit") {
                // Regular edit — show download popup
                setDownloadOpen(true);
            } else if (formType === "Add" && wasCancelled) {
                // Rebooking detected! Show version number prompt
                setRebookingEventData({ ...newEvent, email: email });
                setVersionNumber(2);
                setDraftsStatus('');
                setVersionPromptOpen(true);
            }

        } catch (err) {
            console.error("Error saving event:", err);
        }
    };

    // Confirms the user wants to delete/cancel an event
    const confirmDeleteEvent = () => { setConfirmOpen(true); }

    // Actually deletes the event after confirmation
    const deleteEvent = async () => {
        try {
            const cancelledData = {
                stage: event.stage,
                date: event.date,
                eventId: event.eventID,
                timestamp: Date.now()
            };

            await firebaseDb.child('database/cancellations').push(cancelledData);
            await firebaseDb.child('database/events/' + event.eventID).remove();

            setConfirmOpen(false);
            setOpen(false);
            setDownloadOpen(true);

        } catch (err) {
            console.error("Error cancelling event:", err);
        }
    };

    const currentClient = clientsList?.find(client => client.label === stage);

    // Venue data for document generation
    const venueID = event.venue;
    const [venue, setVenue] = useState(null);
    useEffect(() => {
        if (!venueID) return;
        const ref = firebaseDb.child(`database/venues/${venueID}`);
        ref.on('value', (snapshot) => { setVenue(snapshot.val()); });
        return () => ref.off();
    }, [venueID]);

    const bookings     = BookingListData(month, year, venueID);
    const invoice      = InvoiceSingle(event);
    const confirmation = ConfirmationSingle(event);

    return (
        <>
            {/* ── DIALOG 1: Add / Edit event ───────────────────────────── */}
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    {title}
                    <IconButton aria-label="close" onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Stack spacing={2} sx={{ width: 500 }}>
                        {clientsList !== undefined && clientsList.length !== 0 && (
                            <Autocomplete
                                id="client"
                                options={clientsList.sort((a, b) => a.label - b.label)}
                                value={currentClient}
                                EmailVal={email}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        const { label, emailLabel, labelPerformer, defaultPay } = newValue;
                                        if (label) {
                                            setStage(label);
                                            if (defaultPay !== undefined && defaultPay !== null && defaultPay !== "") {
                                                setPrice(Number(defaultPay));
                                                setIsPriceCustom(true);
                                            } else if (JSON.stringify(label).includes("\u00A0")) {
                                                setPrice(380);
                                                setIsPriceCustom(false);
                                            } else {
                                                setPrice(185);
                                                setIsPriceCustom(false);
                                            }
                                        }
                                        if (emailLabel) setEmail(emailLabel);
                                        if (labelPerformer) setPerformers(labelPerformer);
                                    } else {
                                        if (formType === "Add") {
                                            setStage("");
                                            setEmail("NO_EMAIL_FOR_ARTIST");
                                            setPerformers("");
                                            setPrice(185);
                                            setIsPriceCustom(false);
                                        }
                                    }
                                }}
                                isOptionEqualToValue={(option, value) => option}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        margin="dense" label="Artist" type="text"
                                        fullWidth variant="standard" required
                                        onChange={(event) => {
                                            if (event.target.name === "stage") setStage(event.target.value);
                                            else if (event.target.name === "email") setEmail(event.target.value);
                                        }}
                                    />
                                )}
                            />
                        )}
                        <TextField
                            margin="dense" id="date" label="Date" type="date"
                            value={date} required fullWidth variant="standard"
                            InputLabelProps={{ shrink: true }}
                            onChange={(event) => { setDate(event.target.value) }}
                        />
                        <FormControl required>
                            <FormLabel id="time-radio-buttons-group-label">Time</FormLabel>
                            <RadioGroup
                                aria-labelledby="time-radio-buttons-group-label"
                                value={isTimeCustom ? "custom" : (startTime + "-" + endTime)}
                                name="time-radio-buttons-group"
                                onChange={handleTimeChange}
                            >
                                {(() => {
                                    if (formType === "Add" && matchingEvent === true && matchingEventStartTime === "17:00") return;
                                    const isWeekday = (dayOfWeek >= 1 && dayOfWeek <= 4) || dayOfWeek === 7;
                                    return (
                                        <FormControlLabel
                                            value={isWeekday ? "17:00-19:00" : "17:00-19:30"}
                                            control={<Radio />}
                                            label={isWeekday ? "5:00 PM - 7:00 PM" : "5:00 PM - 7:30 PM"}
                                        />
                                    );
                                })()}
                                {(() => {
                                    const isWeekday = (dayOfWeek >= 1 && dayOfWeek <= 4) || dayOfWeek === 7;
                                    const secondSlotStart = isWeekday ? "19:00" : "19:30";
                                    if (formType === "Add" && matchingEvent === true && matchingEventStartTime === secondSlotStart) return;
                                    const secondSlotEnd = isWeekday ? "21:00" : "22:00";
                                    const label = isWeekday ? "7:00 PM - 9:00 PM" : "7:30 PM - 10:00 PM";
                                    return (
                                        <FormControlLabel
                                            value={`${secondSlotStart}-${secondSlotEnd}`}
                                            control={<Radio />}
                                            label={label}
                                        />
                                    );
                                })()}
                                <FormControlLabel value="custom" control={<Radio />} label="Custom" />
                            </RadioGroup>
                            {isTimeCustom && <Stack spacing={2} sx={{ width: 500 }} direction="row">
                                <TextField
                                    margin="none" id="start-time" label="Start Time"
                                    value={startTime} type="time" variant="standard"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={event => { setStartTime(event.target.value) }}
                                />
                                <TextField
                                    margin="none" id="end-time" label="End Time"
                                    value={endTime} type="time" variant="standard"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(event) => { setEndTime(event.target.value) }}
                                />
                            </Stack>}
                        </FormControl>
                        <FormControl required>
                            <FormLabel id="price-radio-buttons-group-label">Price</FormLabel>
                            <RadioGroup
                                aria-labelledby="price-radio-buttons-group-label"
                                value={isPriceCustom ? "custom" : price}
                                name="price-radio-buttons-group"
                                onChange={handlePriceChange}
                            >
                                {(() => {
                                    switch (dayOfWeek) {
                                        case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                                            return <FormControlLabel value="185" type="number" control={<Radio />} label="$185" />;
                                        default:
                                            return <p>This is not a day of the week</p>;
                                    }
                                })()}
                                {(() => {
                                    switch (dayOfWeek) {
                                        case 1: case 2: case 3: case 4: case 5: case 6: case 7:
                                            return <FormControlLabel value="380" type="number" control={<Radio />} label="$380" />;
                                        default:
                                            return <p>This is not a day of the week</p>;
                                    }
                                })()}
                                <FormControlLabel value="custom" control={<Radio />} label="Custom" />
                            </RadioGroup>
                            {isPriceCustom && <Stack spacing={2} sx={{ width: 500 }} direction="row">
                                <TextField
                                    margin="dense" id="custom-price" value={price}
                                    label="Price" fullWidth variant="standard"
                                    onChange={(event) => { setPrice(parseFloat(event.target.value)) }}
                                    type="number"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start"><AttachMoney /></InputAdornment>
                                        ),
                                    }}
                                />
                            </Stack>}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={savePriceForClient}
                                        onChange={(e) => setSavePriceForClient(e.target.checked)}
                                        disabled={!stage}
                                    />
                                }
                                label="Save this pay for this client"
                            />
                        </FormControl>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    {formType === "Edit" && (
                        <Button color="error" onClick={() => setConfirmOpen(true)}>
                            Cancel Event
                        </Button>
                    )}
                    <div style={{flex: '1 0 0'}} />
                    <Button onClick={submitEvent}>Submit</Button>
                </DialogActions>
            </Dialog>

            {/* ── DIALOG 2: Confirm cancellation ──────────────────────── */}
            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle>Confirm cancellation</DialogTitle>
                <DialogContent>
                    Are you sure you want to cancel this event?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>Back</Button>
                    <Button onClick={deleteEvent} color="error" variant="contained">Confirm</Button>
                </DialogActions>
            </Dialog>

            {/* ── DIALOG 3: Download files after edit/cancel ───────────── */}
            <Dialog open={downloadOpen} onClose={() => setDownloadOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    Download new files
                    <IconButton aria-label="close" onClick={() => setDownloadOpen(false)}
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogActions>
                    <Stack spacing={2} width="100%">
                        <Button
                            variant="contained" endIcon={<DownloadIcon />}
                            disabled={!venue || !event}
                            onClick={async () => {
                                const doc = InvoiceGenerate(invoice, venue);
                                const blob = await pdf(doc).toBlob();
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = `${venue.name === "Renaissance-Exchange" ? "Exchange" : venue.name} Booking Invoice - ${invoice.dateForFile} ${invoice.startTime === "05:00" ? "#1" : "#2"} - Revised.pdf`;
                                link.click();
                                URL.revokeObjectURL(url);
                            }}
                        >
                            Download Invoice
                        </Button>

                        <Button
                            variant="contained" endIcon={<DownloadIcon />}
                            disabled={!onDownloadCalendar}
                            onClick={() => onDownloadCalendar && onDownloadCalendar('original')}
                        >
                            Download Calendar (Original)
                        </Button>

                        <Button
                            variant="contained" endIcon={<DownloadIcon />}
                            disabled={!onDownloadCalendar}
                            onClick={() => onDownloadCalendar && onDownloadCalendar('merged')}
                        >
                            Download Calendar (Merged)
                        </Button>

                        <Button
                            variant="contained" endIcon={<DownloadIcon />}
                            disabled={!venue || !bookings.length}
                            onClick={async () => {
                                const doc = BookingListGenerate({ bookings, venue, month, year });
                                const blob = await pdf(doc).toBlob();
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = `${venue.name === "Renaissance-Exchange" ? "Exchange" : venue.name} - Booking List - ${month} ${year} - V1.pdf`;
                                link.click();
                                URL.revokeObjectURL(url);
                            }}
                        >
                            Download Booking List
                        </Button>

                        <Button
                            variant="contained" endIcon={<DownloadIcon />}
                            disabled={!venue || !event}
                            onClick={async () => {
                                const doc = ConfirmationGenerate(confirmation, venue);
                                const blob = await pdf(doc).toBlob();
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = `${venue.name === "Renaissance-Exchange" ? "Exchange" : venue.name} Artist Confirmation - ${confirmation.dateForFile} ${confirmation.startTime === "05:00" ? "#1" : "#2"} - Revised.pdf`;
                                link.click();
                                URL.revokeObjectURL(url);
                            }}
                        >
                            Download Artist Confirmation
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>

            {/* ── DIALOG 4: Rebooking version prompt ──────────────────── */}
            <Dialog open={versionPromptOpen} onClose={() => setVersionPromptOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <EmailIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'primary.main' }} />
                    Rebooking Detected!
                    <IconButton aria-label="close" onClick={() => setVersionPromptOpen(false)}
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        This replaces a cancelled booking. The system will automatically
                        create <strong>10 Gmail drafts</strong> with all revised documents attached.
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        What version number should be used for this month's revised documents?
                    </Typography>
                    <TextField
                        label="Version Number"
                        type="number"
                        value={versionNumber}
                        onChange={(e) => setVersionNumber(parseInt(e.target.value) || 2)}
                        inputProps={{ min: 2, max: 9 }}
                        fullWidth
                        variant="outlined"
                        helperText={`Documents will be labeled V${versionNumber} — e.g. "Exchange Calendar-${month} ${year} V${versionNumber}"`}
                    />
                    {draftsStatus && (
                        <Typography
                            variant="body2"
                            sx={{
                                mt: 2,
                                color: draftsStatus.startsWith('✅') ? 'green'
                                     : draftsStatus.startsWith('❌') ? 'red'
                                     : 'text.secondary'
                            }}
                        >
                            {draftsStatus}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setVersionPromptOpen(false);
                            setDownloadOpen(true); // Fall back to manual download popup
                        }}
                        disabled={isCreatingDrafts}
                    >
                        Skip — Just Download Files
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isCreatingDrafts}
                        startIcon={isCreatingDrafts ? <CircularProgress size={16} color="inherit" /> : <EmailIcon />}
                        onClick={() => {
                            if (rebookingEventData && venue) {
                                createRebookingDrafts(
                                    versionNumber,
                                    rebookingEventData,
                                    venue,
                                    bookings,
                                    InvoiceSingle(rebookingEventData),
                                    ConfirmationSingle(rebookingEventData)
                                );
                            }
                        }}
                    >
                        {isCreatingDrafts ? 'Creating Drafts...' : 'Create 10 Gmail Drafts'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
